const baseUrl = {
  online: 'dingxinwen.com',
  test: 'dingnews.net'
}[process.env.API_ENV]

const config = {
  baseUrl,
  app_id: "210816682548850701",
  app_secret: "d22c98b028383d3d99fa68da66c30e25"
}


export default {
  install: function (Vue) {
    Vue.prototype.$config = config;
  },
  ...config
}